module.exports = __webpack_public_path__ + "static/media/PeakFitness.21624b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PeakFitness.png
// module id = 51
// module chunks = 0